import { render, staticRenderFns } from "./QueryDiff.vue?vue&type=template&id=72d72d51&scoped=true&"
import script from "./QueryDiff.vue?vue&type=script&lang=js&"
export * from "./QueryDiff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d72d51",
  null
  
)

export default component.exports